module.exports = __webpack_public_path__ + "img/img_app_band_football.9cd78b92.png";